import { Component } from '@angular/core';
import { ServiceCategoryService } from '../services/service.category.service';

@Component({
  selector: 'app-service-category-pagination',
  templateUrl: './service-category-pagination.component.html'
})
export class ServiceCategoryPaginationComponent {
  constructor(public service: ServiceCategoryService) { }

  onPaginate(page: number) {
    this.service.currentPage = page;
    this.service.search();
  }
}
